import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

// UnoCSS + 全局样式
import 'virtual:uno.css';
import '@/assets/styles/index.scss';

// Element Plus 命令式 API 的样式：ElementPlusResolver 只会在「显式 import { ElMessageBox } from 'element-plus'」
// 时跳过样式注入，导致弹窗无样式格式错乱。这里手动引入。
import 'element-plus/theme-chalk/src/message.scss';
import 'element-plus/theme-chalk/src/message-box.scss';
import 'element-plus/theme-chalk/src/notification.scss';
import 'element-plus/theme-chalk/src/loading.scss';

// nprogress
import 'nprogress/nprogress.css';

// 权限路由守卫
import '@/router/guard';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');
